import { FC } from "react";

import Link from "next/link";

import { Modal, Empty } from "antd";

import Avatar from "@/components/Avatar";
import { tier_temporary } from "@/components/pages/search/search-profiles";

import { useGetMutualConnection } from "@/hooks/useConnections";

import { PAGE_URL } from "@/utils/constants";
import { userTypeConvert } from "@/utils/helper";

interface IModalMutualConnection {
  idUser: string;
  isOpen: boolean;
  onClose: () => void;
}

const ModalMutualConnection: FC<IModalMutualConnection> = ({ isOpen, onClose, idUser }) => {
  const { data, isLoading, isError } = useGetMutualConnection(idUser);

  return (
    <Modal onCancel={onClose} footer={null} open={isOpen} title="Mutual Connections">
      <div className="grid gird-cols-1 gap-8 py-4">
        {isLoading ? (
          <>
            <div className="animate-pulse">
              <div className="w-full h-24 bg-neutral-700 rounded-lg "></div>
            </div>
            <div className="animate-pulse">
              <div className="w-full h-24 bg-neutral-700 rounded-lg "></div>
            </div>
          </>
        ) : data?.mutualConnectionWithCG?.length > 0 && !isError ? (
          data?.mutualConnectionWithCG.map((item: any, i: number) => (
            <Link
              href={`${PAGE_URL.profile}/${item?.userId}`}
              key={i}
              className="flex items-center justify-between gap-4"
            >
              <div className="inline-block">
                <Avatar
                  src={item?.user?.avatarUrl}
                  size="md"
                  alt="members"
                  type_tier={tier_temporary(item?.user?.points)}
                  badge={item?.CGPercent || null}
                  name={item?.user?.bio?.firstName}
                />
              </div>

              <div className="flex-1">
                <p className="text-neutral-300">{item?.user?.jobTitle}</p>
                <h4 className="text-lg font-bold text-white">
                  {`${item?.user?.firstName} ${item?.user?.lastName}`}
                </h4>
                {item?.user?.lookingForType && (
                  <p className="text-neutral-400">
                    {item?.user?.type ? `${userTypeConvert(item?.user?.type)}, ` : ""}Actively
                    Looking for {userTypeConvert(item?.user?.lookingForType)}
                  </p>
                )}
              </div>
            </Link>
          ))
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    </Modal>
  );
};

export default ModalMutualConnection;
